function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import Mixin from './mixin';
export default {
  name: buildComponentName('TimelineItem'),
  mixins: [Mixin],
  props: {
    color: {
      type: String,
      default: 'blue'
    }
  },
  computed: {
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-item");
    },
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, prefixCls, true);
    },
    dotStyle: function dotStyle() {
      var color = this.color;
      return /^blue|red|green$/.test(color) ? undefined : {
        borderColor: color
      };
    }
  },
  render: function render() {
    var _dotCls;

    var h = arguments[0];
    var _this$$slots = this.$slots,
        slotDefault = _this$$slots.default,
        slotDot = _this$$slots.dot,
        prefixCls = this.prefixCls,
        classes = this.classes,
        color = this.color,
        dotStyle = this.dotStyle;
    var dotCls = (_dotCls = {}, _defineProperty(_dotCls, "".concat(prefixCls, "-head"), true), _defineProperty(_dotCls, "".concat(prefixCls, "-head-custom"), !!slotDot), _defineProperty(_dotCls, "".concat(prefixCls, "-head-").concat(color), !!color), _dotCls);
    return h("li", {
      "class": classes
    }, [h("div", {
      "class": "".concat(prefixCls, "-tail")
    }), h("div", {
      "class": dotCls,
      "style": dotStyle
    }, [slotDot]), h("div", {
      "class": "".concat(prefixCls, "-content")
    }, [slotDefault])]);
  }
};